import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction, fetchApi } from "@inmagik/react-crud"
import type { Blog } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useBlogsList(params: Record<string, string> = {}) {
  return useList<Blog>(`${API_URL}/admin/blogs`, {
    query: params,
  })
}

export function useBlog(id: number | undefined) {
  return useDetail<Blog>(`${API_URL}/admin/blogs`, id?.toString())
}

export function useCreateBlog() {
  return useCreate<Blog>(`${API_URL}/admin/blogs`, {
    encode: "formdata",
  })
}

export function useUpdateBlog() {
  return useUpdate<Blog>(`${API_URL}/admin/blogs`, {
    encode: "formdata",
  })
}

export function useDeleteBlog() {
  return useDelete(`${API_URL}/admin/blogs`)
}

export function usePartialUpdateBlog() {
  return usePartialUpdate<Blog>(`${API_URL}/admin/blogs`)
}

export function useDeleteMultiBlog() {
  return useAction(`${API_URL}/admin/blogs/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useBlogLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/blogs/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Blog>
  }, [])
}

export function useBlogsLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/blogs?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Blog[] }>
  }, [])
}
